import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LayoutGrid } from "lucide-react";
import {
  HOME_CARD_LABELS,
  type HomeCardKey,
  type HomeCardsPreferences,
} from "@/lib/homeCardsPreferences";

const CARD_KEYS = Object.keys(HOME_CARD_LABELS) as HomeCardKey[];

interface HomeCustomizeMenuProps {
  prefs: HomeCardsPreferences;
  onToggle: (key: HomeCardKey, enabled: boolean) => void;
}

export function HomeCustomizeMenu({ prefs, onToggle }: HomeCustomizeMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {/* DS EDIT 5aug26 — icon-only so it fits the single chat header row */}
        <Button
          variant="ghost"
          size="icon"
          className="relative flex-shrink-0 h-9 w-9 sm:h-8 sm:w-8"
          title="Customize home"
          aria-label="Customize home"
          data-testid="button-customize-home"
        >
          <LayoutGrid className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Home cards</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {CARD_KEYS.map((key) => (
          <DropdownMenuCheckboxItem
            key={key}
            checked={prefs[key]}
            onCheckedChange={(checked) => onToggle(key, checked === true)}
          >
            {HOME_CARD_LABELS[key]}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
